<template>
  <div class="ordercenter">
    <div class="page-title">
      <div>订单中心</div>
    </div>
    <div class="nav-tabpanel-box">
      <div :class="['item-nav-box', selTabIndex == 100001 ? 'active' : '']" @click="handleSelTab(100001)">
        报价列表
      </div>
      <div :class="['item-nav-box', selTabIndex == 200002 ? 'active' : '']" @click="handleSelTab(200002)">
        充值订单
      </div>
      <div :class="['item-nav-box', selTabIndex == 300003 ? 'active' : '']" @click="handleSelTab(300003)">
        项目订单
      </div>
      <div :class="['item-nav-box', selTabIndex == 400004 ? 'active' : '']" @click="handleSelTab(400004)">
        分销订单
      </div>
    </div>
    <template v-if="selTabIndex == 100001">
      <div class="table-header-box recharge cell-row">
        <div class="cell-column offername">任务名称</div>
        <div class="cell-column offertype">审核状态</div>
        <div class="cell-column offermoney">报价金额</div>
        <div class="cell-column offertime">最新提交时间</div>
        <div class="cell-column offerHandle">操作</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="offer-num-box ">
            <div>报价编号：<span class="order-num">{{ item.id_public_middle_table }}</span></div>
            <el-upload
              v-if="item.mid_table_remark_009==9003"
              action="no"
              accept=".png,.jpg,.jpeg"
              :auto-upload="false"
              :multiple="false"
              :show-file-list="false"
              :on-change="
                (file, fileList) => {
                  handleUpload(file, fileList, idx);
                }
              "
            >
              <div class="upload-code">上传支付宝收款码</div>
            </el-upload>
          </div>
          <div class="cell-row">
            <div class="cell-column offername">{{ item.mid_table_remark_005 }}</div>
            <template v-if="item.mid_table_remark_007==7001">
              <div class="cell-column offertype color9002">竞标中</div>
            </template>
            <div
              v-else-if="item.mid_table_remark_007==7002"
              class="cell-column offertype"
              :class="item.mid_table_remark_009?'color'+item.mid_table_remark_009:'color9001'"
            >
              {{ item.mid_table_remark_009==9002?'审核中':(item.mid_table_remark_009==9003?'已通过':(item.mid_table_remark_009==9004?'未通过':'未提交')) }}
            </div>
            <template v-if="item.mid_table_remark_007==7003">
              <div class="cell-column offertype gray">已失效</div>
            </template>
            <div class="cell-column offermoney">{{ item.mid_table_remark_006 }}</div>
            <div class="cell-column offertime">{{ item.time_4_begin||'--' }}</div>
            <div class="cell-column offerHandle">
              <div class="handleItem width85 red" @click="downloadTaskZip(idx)">需求包下载</div>
              <template v-if="item.mid_table_remark_007==7002">
                <div
                  class="handleItem width85"
                  :class="item.mid_table_remark_011?'red':'pink'"
                  @click="downloadReviewZip(idx)"
                >
                  任务包下载
                </div>
                <div v-if="item.mid_table_remark_009==9003||item.mid_table_remark_009==9004" class="handleItem width85 pink">任务包上传</div>
                <el-upload
                  v-else
                  action="no"
                  accept=".zip"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      handleChange(file, fileList, idx);
                    }
                  "
                >
                  <div class="handleItem width85 red">任务包上传</div>
                </el-upload>
              </template>
              <div v-if="item.mid_table_remark_007==7001" class="handleItem width40 red" @click="revoke(idx)">撤销报价</div>
              <template v-else-if="item.mid_table_remark_007==7002">
                <div v-if="!item.mid_table_remark_009||item.mid_table_remark_009==9001" class="handleItem width40 red" @click="revokeAll(idx)">撤销中标</div>
                <div v-else class="handleItem width40 pink">撤销中标</div>
              </template>
              <div v-else class="handleItem width40 pink">撤销报价</div>
            </div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-if="selTabIndex == 200002">
      <div class="table-header-box recharge cell-row">
        <div class="cell-column ordertype">订单类型</div>
        <div class="cell-column orderpaytype">支付方式</div>
        <div class="cell-column paytime">支付时间</div>
        <div class="cell-column couponmoney">优惠金额</div>
        <div class="cell-column surplusmoney">余额抵扣</div>
        <div class="cell-column realpay">实付金额</div>
        <div class="cell-column orderstatus">订单状态</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="order-num-box">
            订单号：<span class="order-num">{{ item.id_public_goods_order_record }}</span>
          </div>
          <div class="cell-row">
            <div class="cell-column ordertype">{{ item.append_order_remark_003|showRechargeName }}</div>
            <div class="cell-column orderpaytype">{{ item.ways_of_payment|showWayOfPayment }}</div>
            <div class="cell-column paytime">{{ item.time_update }}</div>
            <div class="cell-column couponmoney">{{ item.pay_by_quan==0?'0.00':(item.pay_by_quan.toFixed(2)) }}</div>
            <div class="cell-column surplusmoney">{{ item.pay_by_left_money==0?'0.00':(item.pay_by_left_money.toFixed(2)) }}</div>
            <div class="cell-column realpay">{{ item.pay_by_online.toFixed(2) }}</div>
            <div class="cell-column orderstatus">{{ item.ship_state|showOrderStatus }}</div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-if="selTabIndex == 300003">
      <div class="table-header-box cell-row">
        <div class="cell-column ordertype">订单类型</div>
        <div class="cell-column orderpaytype">支付方式</div>
        <div class="cell-column paytime">支付时间</div>
        <div class="cell-column couponmoney">优惠金额</div>
        <div class="cell-column surplusmoney">余额抵扣</div>
        <div class="cell-column realpay">实付金额</div>
        <div class="cell-column orderstatus">订单状态</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row">
          <div class="order-num-box">
            订单号：<span class="order-num">{{ item.id_public_goods_order_record }}</span>
          </div>
          <div class="cell-row">
            <div class="cell-column ordertype">项目付费</div>
            <div class="cell-column orderpaytype">{{ item.ways_of_payment|showWayOfPayment }}</div>
            <div class="cell-column paytime">{{ item.time_update }}</div>
            <div class="cell-column couponmoney">{{ item.pay_by_quan==0?'0.00':(item.pay_by_quan.toFixed(2)) }}</div>
            <div class="cell-column surplusmoney">{{ item.pay_by_left_money==0?'0.00':(item.pay_by_left_money.toFixed(2)) }}</div>
            <div class="cell-column realpay">{{ item.pay_by_online.toFixed(2) }}</div>
            <div class="cell-column orderstatus">{{ item.ship_state|showOrderStatus }}</div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
    <template v-if="selTabIndex == 400004">
      <div class="table-header-box cell-row distribution">
        <div class="cell-column distributionid">分销ID</div>
        <div class="cell-column avatar">头像</div>
        <div class="cell-column username">姓名</div>
        <div class="cell-column userphone">手机号</div>
        <div class="cell-column distributionordertype">订单类型</div>
        <div class="cell-column distributionmoney">订单总金额</div>
        <div class="cell-column fanyongmoney">返佣金额</div>
      </div>
      <div class="table-list-box" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
        <template v-if="orderList.length">
        <div v-for="(item, idx) in orderList" :key="idx" class="datalist-row distribution">
          <div class="order-num-box">
            订单号：<span class="order-num">{{ item.ordernum }}</span>
            <span class="distribute-paytime">支付时间：{{item.time_update}}</span>
          </div>
          <div class="cell-row">
            <div class="cell-column distributionid">{{ item.distributionid }}</div>
            <div class="cell-column avatar"><img class="user-avatar" :src="item.avatar" /></div>
            <div class="cell-column username">{{ item.username }}</div>
            <div class="cell-column userphone">{{ item.userphone }}</div>
            <div class="cell-column distributionordertype">{{ item.distributionordertype }}</div>
            <div class="cell-column distributionmoney">{{ item.distributionmoney }}</div>
            <div class="cell-column fanyongmoney">{{ item.fanyongmoney }}</div>
          </div>
        </div>
        </template>
        <NoneData v-else></NoneData>
      </div>
    </template>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import NoneData from "@/components/NoneData";
import pageCommon from "@/utils/pagecommon";
import orderApi from "@/api/order";
import taskApi from "@/api/task";
import { formatDate } from "@/utils/tool";
export default {
  name: "OrderCenter",
  components: {NoneData},
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 2);
    _this.selTabIndex=100001;
    if(_this.selTabIndex==100001){
        // _this.getGotList();
      }else{
        _this.getOrderList();
      }
  },
  mounted() {
    let _this = this;
  },
  data() {
    return {
      rechargeList: [],
      projectList: [],
      distributionList: [],
      selTabIndex: 100001,
      orderList:[],
      currentPage:1,
      pageSize:10,
      disabledLoadMore:false
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
  },
  mounted: function () {
  },
  filters: {
    showRechargeName:function(val){
      let arr=val.split("-_-");
      return `${arr[0]}-${arr[1].split(';')[0]}个月`
    },
    showWayOfPayment:function(val){
      if(val){
        let type=`${val}`[0];
        if(type==4){
          return "微信"
        }
        if(type==3){
          return "支付宝"
        }
        if(type==1){
          return "余额"
        }
      }
      return "";
    },
    showOrderStatus:function(val){
      if(val==1){
        return "支付成功";
      }
      if(val==8){
        return "支付失败";
      }
      if(val==14){
        return "待支付";
      }
      return "";
    },
    showStatus: function (val) {
      if (val) {
        return "远程开发";
      }
      return "本地开发";
    },
  },
  methods: {
    handleSelTab: function (idx) {
      let _this = this;
      if (_this.selTabIndex == idx) {
        return;
      }
      _this.selTabIndex = idx;
      _this.currentPage=1;
      _this.orderList=[];
      if(_this.selTabIndex==100001){
        _this.getGotList();
      }else{
        _this.getOrderList();
      }
    },
    getGotList: function () {
      let _this = this;
      let requestTaskData = {
        isloading: true,
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        mid_table_remark_007:'7002,7001,7003',
        id_public_user_info: _this.userInfo.id_public_user_info,
        is_online:'0,1'
      };
      pageCommon.apiRequestCommon(taskApi, "getOfferData", requestTaskData).then(
        (res) => {
          let orderList = res.page_content;
          if (orderList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          _this.orderList.push(...orderList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          console.log(err)
          _this.isRequesting = false;
          _this.orderList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    getOrderList: function () {
      let _this = this;
      let requestData = {
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        type_order_4_application:_this.selTabIndex,
        id_public_user_info: _this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon.apiRequestCommon(orderApi, "getList", requestData).then(
        (res) => {
          let orderList = res.public_order_list;
          if (orderList.length < _this.pageSize) {
            _this.disabledLoadMore = true;
          }
          _this.orderList.push(...orderList);
          _this.total = res.result_num;
          _this.isRequesting = false;
        },
        (err) => {
          _this.isRequesting = false;
          _this.orderList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    downloadTaskZip(idx){
      let _this = this;
      let requestData = {
        isloading: true,
        id_public_middle_table: this.orderList[idx].mid_table_remark_004
      };
      pageCommon.apiRequestCommon(taskApi, "getAllTaskData", requestData).then(
        (res) => {
          if(res.result_num>0){
            if(res.page_content[0].mid_table_remark_015){
              window.open(res.page_content[0].mid_table_remark_015)
            } else {
              this.$message.error("此任务没有任务包，请联系工作人员解决");
            }
          } else {
            this.$message.error("此任务已下线，请联系工作人员");
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
          }
        }
      );
    },
    downloadReviewZip(idx){
      if(!this.orderList[idx].mid_table_remark_011){
        return
      }
      window.open(this.orderList[idx].mid_table_remark_011)
    },
    handleChange: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_009: 9002,
            mid_table_remark_011: res,
            mid_table_remark_013: 1304,
            time_4_begin: formatDate(new Date(),"YYYY-MM-DD hh:mm:ss")
          }
          let requestTaskData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].mid_table_remark_004,
            mid_table_remark_013: 1304,
          }
          pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              pageCommon.apiRequestCommon(taskApi, "insertTaskData", requestTaskData).then(
                (res) => {
                  _this.$message.success("上传成功");
                  this.$set(this.orderList,idx,newData)
                },
                (err) => {
                }
              )
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    handleUpload: function (file, fileList, idx) {
      let _this = this;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return;
      }
      data = JSON.parse(Base64.decode(data));
      this.$uploadNormal(data, file, false).then(
        (res) => {
          let requestData = {
            isloading: true,
            id_public_middle_table: this.orderList[idx].id_public_middle_table,
            mid_table_remark_014: res,
            mid_table_remark_016: 1601,
          }
          pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
            (res) => {
              var newData=res.page_content[0]
              _this.$message.success("上传成功");
              this.$set(this.orderList,idx,newData)
            },
            (err) => {
            }
          )
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    loadMoreData: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting=true;
      _this.currentPage += 1;
      if(_this.selTabIndex==100001){
        _this.getGotList();
      }else{
        _this.getOrderList();
      }
    },
    revokeAll(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经中标的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_007:7003
        }
        let requestOnlineData = {
          isloading: true,
          pre_db_para_mid_table_remark_004: this.orderList[idx].mid_table_remark_004,
          id_public_middle_table: -1,
          is_online: 1
        }
        let requestTaskData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].mid_table_remark_004,
          mid_table_remark_013: 1301,
        }
        pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestOnlineData).then(
              (res) => {
                pageCommon.apiRequestCommon(taskApi, "insertTaskData", requestTaskData).then(
                  (res) => {
                    this.$set(this.orderList,idx,newData)
                  },
                  (err) => {
                    if (err.sysUserLoginError) {
                      _this.$message.error("系统异常，请稍后刷新重试！");
                    } else {
                    }
                  }
                );
              },
              (err) => {
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                }
              }
            );
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      });      
    },
    revoke(idx){
      let _this = this;
      this.$confirm('此操作将会撤销已经提交的报价, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {
          isloading: true,
          id_public_middle_table: this.orderList[idx].id_public_middle_table,
          mid_table_remark_007:7003
        }
        pageCommon.apiRequestCommon(taskApi, "insertOfferData", requestData).then(
          (res) => {
            var newData=res.page_content[0];
            this.$set(this.orderList,idx,newData)
          },
          (err) => {
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
            }
          }
        );
      }).catch(() => {         
      }); 
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.ordercenter {
  position: relative;
  width: 100%;
  // height: 100%;
  height: 1131px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .nav-tabpanel-box {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    margin-top: 40px;
    .item-nav-box {
      position: relative;
      height: 32px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      color: #222222;
      line-height: 18px;

      box-sizing: border-box;
      cursor: pointer;
      margin-right: 64px;
      &.active {
        color: #ec4040;
        font-weight: bold;
        &::after {
          position: absolute;
          width: 100%;
          content: "";
          height: 4px;
          background: #ec4040;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .offername{
    width: 130px;
    text-align: left;
  }
  .offertype{
    width: 130px;
    text-align: center;
  }
  .offermoney{
    width: 130px;
    text-align: center;
  }
  .offertime{
    width: 198px;
    text-align: center;
  }
  .offerHandle{
    width: 350px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .handleItem{
      text-align:center;
      &.width85{
        width:103px;
      }
      &.width45{
        width:45px;
      }
      &.red{
        color: #ec4040;
        cursor:pointer;
      }
      &.pink{
        color:#FFA8A8;
        cursor:normal;
      }
    }
  }
  .ordertype {
    width: 116px;
    text-align: left;
  }
  .orderpaytype {
    width: 114px;
    text-align: center;
  }
  .paytime {
    width: 198px;
    text-align: center;
  }
  .couponmoney {
    width: 124px;
    text-align: center;
  }
  .surplusmoney {
    width: 137px;
    text-align: center;
  }
  .realpay {
    width: 142px;
    text-align: center;
  }
  .orderstatus {
    width: 98px;
    text-align: right;
  }
  .distributionid {
    width: 141px;
    text-align: left;
  }
  .avatar {
    width: 42px;
    text-align: center;
    .user-avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
  }
  .username {
    width: 162px;
    text-align: center;
  }
  .userphone {
    width: 153px;
    text-align: center;
  }
  .distributionordertype {
    width: 141px;
    text-align: center;
  }
  .distributionmoney {
    width: 155px;
    text-align: center;
  }
  .fanyongmoney {
    width: 131px;
    text-align: right;
  }
  .table-header-box {
    position: relative;
    align-items: baseline;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 36px;
    margin-bottom: 20px;
    align-items: center;
    &.recharge {
      align-items: center;
      // padding-top: 18px;
    }
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
    &.distribution {
      width: 100%;
      padding-left: 25px;
      padding-right: 15px;
      box-sizing: border-box;
    }
  }
  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    position: relative;
    height: 120px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 25px;

    &:last-child {
      margin-bottom: 0;
    }
    .order-num-box {
      position: relative;
      width: 988px;
      height: 40px;
      background: #f4f4f4;
      border-radius: 4px 4px 0px 0px;
      box-sizing: border-box;
      margin: 0 auto;
      padding-left: 24px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: left;
      .order-num {
        padding-left: 10px;
      }
      .distribute-paytime {
        padding-left: 24px;
      }
    }
    .offer-num-box{
      position: relative;
      width: 988px;
      height: 40px;
      background: #f4f4f4;
      border-radius: 4px 4px 0px 0px;
      box-sizing: border-box;
      margin: 0 auto;
      padding:0 28px 0 24px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: left;
      display:flex;
      justify-content: space-between;
      .upload-code{
        color: #0072FF;
      }
    }
    .cell-row {
      margin-top: 31px;
    }
    &.distribution {
      .cell-row {
        margin-top: 18px;
        padding-right: 15px;
      }
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      &.color9001{
        color: #ff9e13;
      }
      &.color9002{
        color: #0072ff;
      }
      &.color9003{
        color: #208227;
      }
      &.color9004{
        color: #e62c17;
      }
      &.red{
        color: #ec4040;
        font-weight: bolder;
        cursor:pointer;
      }
      &.gray{
        color:#878787;
        cursor:normal;
      }
    }
    .couponmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .surplusmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .realpay {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #000000;
      &.red{
        color: #ec4040;
      }
    }
    .fanyongmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
  }
}
</style>
